import React, { useState, useEffect } from 'react';

import { initializeApp } from 'firebase/app';

import { getAuth, onAuthStateChanged, signInWithPopup, GoogleAuthProvider, getRedirectResult } from 'firebase/auth';

import { getFirestore, collection, doc, setDoc, onSnapshot, addDoc, updateDoc, deleteDoc, query } from 'firebase/firestore';

import { UserPlus, CheckCircle, HelpCircle, XCircle, Trash2, Edit2, Check, X, Save } from 'lucide-react';



// Firebase konfiguráció

const firebaseConfig = {
  apiKey: "AIzaSyAh6vYIJVxKpZ-8L73PZn5-f3xgCa18j-I",
  authDomain: "birthdayapp-b25eb.firebaseapp.com",
  projectId: "birthdayapp-b25eb",
  storageBucket: "birthdayapp-b25eb.firebasestorage.app",
  messagingSenderId: "194422495430",
  appId: "1:194422495430:web:0dbf27f098462055445fc7"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

const db = getFirestore(app);

const appId = typeof firebaseConfig.appId !== 'undefined' ? firebaseConfig.appId : 'birthday-guest-list';



const STATUSES = {

  COMING: 'coming',

  MAYBE: 'maybe',

  NOT_COMING: 'not_coming'

};



const STATUS_CONFIG = {

  [STATUSES.COMING]: { label: 'Jön', color: 'bg-green-100 text-green-700', icon: CheckCircle },

  [STATUSES.MAYBE]: { label: 'Talán', color: 'bg-yellow-100 text-yellow-700', icon: HelpCircle },

  [STATUSES.NOT_COMING]: { label: 'Nem jön', color: 'bg-red-100 text-red-700', icon: XCircle },

};



export default function App() {

  const [user, setUser] = useState(null);

  const [guests, setGuests] = useState([]);

  const [newName, setNewName] = useState('');

  const [editingId, setEditingId] = useState(null);

  const [editingName, setEditingName] = useState('');

  const [loading, setLoading] = useState(true);



  // Auth inicializálás

  useEffect(() => {
    // 1. FIGYELŐ: Ez fut le, ha a felhasználó belép vagy kilép
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    // 2. REDIRECT KEZELÉS: Ha mégis Redirectet használnál, ez kapja el az eredményt visszatéréskor
    getRedirectResult(auth)
        .then((result) => {
          if (result) {
            console.log("Sikeres redirect belépés:", result.user);
          }
        })
        .catch((error) => {
          console.error("Redirect hiba:", error.message);
        });

    // Takarítás: leiratkozunk a figyelőről, ha a komponens megszűnik
    return () => unsubscribe();
  }, []);



  // Adatok betöltése

  useEffect(() => {

    if (!user) return;



    const guestsRef = collection(db, 'birthday_guests');

    const q = query(guestsRef);

    console.log(q)

    const unsubscribe = onSnapshot(q, (snapshot) => {

      const guestData = snapshot?.docs?.map(doc => ({
        id: doc.id,
        ...doc.data()
      })) || [];

      setGuests(guestData ? guestData : []);

      setLoading(false);

    }, (error) => {

      console.error("Firestore error:", error);

      setLoading(false);

    });



    return () => unsubscribe();

  }, [user]);


  const addGuest = async (e) => {

    e.preventDefault();

    if (!newName.trim() || !user) return;

    try {

      const guestsRef = doc(db, 'birthday_guests', 'KRe2B3WpQmOvHi0Mpmz5WxPpsnF2');

      await setDoc(guestsRef, {

        name: newName.trim(),

        status: STATUSES.MAYBE,

        createdAt: Date.now()

      });

      setNewName('');

    } catch (error) {

      console.error("Error adding guest:", error);

    }

  };



  const updateStatus = async (id, newStatus) => {

    if (!user) return;

    try {

      const guestDoc = doc(db, 'birthday_guests', 'KRe2B3WpQmOvHi0Mpmz5WxPpsnF2');

      await updateDoc(guestDoc, { status: newStatus });

    } catch (error) {

      console.error("Error updating status:", error);

    }

  };



  const deleteGuest = async (id) => {

    if (!user) return;

    try {

      const guestDoc = doc(db, 'birthday_guests', 'KRe2B3WpQmOvHi0Mpmz5WxPpsnF2');

      await deleteDoc(guestDoc);

    } catch (error) {

      console.error("Error deleting guest:", error);

    }

  };



  const startEdit = (guest) => {

    setEditingId(guest.id);

    setEditingName(guest.name);

  };



  const saveEdit = async (id) => {

    if (!editingName.trim() || !user) return;

    try {

      const guestDoc = doc(db, 'birthday_guests', 'KRe2B3WpQmOvHi0Mpmz5WxPpsnF2');

      await updateDoc(guestDoc, { name: editingName.trim() });

      setEditingId(null);

    } catch (error) {

      console.error("Error editing guest:", error);

    }

  };



  const getStats = () => {

    const stats = {

      [STATUSES.COMING]: guests.filter(g => g.status === STATUSES.COMING).length,

      [STATUSES.MAYBE]: guests.filter(g => g.status === STATUSES.MAYBE).length,

      [STATUSES.NOT_COMING]: guests.filter(g => g.status === STATUSES.NOT_COMING).length,

    };

    return stats;

  };



  const stats = getStats();

  const loginGoogle = () => signInWithPopup(auth, new GoogleAuthProvider());
  const logout = () => auth.signOut();

  return (

      user ?

      <div className="min-h-screen bg-slate-50 p-4 md:p-8 font-sans text-slate-900">

        <div className="max-w-2xl mx-auto">

          {/* Header */}

          <div className="mb-8 text-center">

            <h1 className="text-4xl font-bold text-indigo-600 mb-2">Szülinapi Vendéglista</h1>

            <p className="text-slate-500">Kezeld a meghívottakat egyszerűen!</p>

            <button onClick={logout}>Kijelentkezés</button>

          </div>



          {/* Stats Summary */}

          <div className="grid grid-cols-3 gap-4 mb-8">

            {Object.entries(STATUS_CONFIG).map(([key, config]) => (

                <div key={key} className={`${config.color} p-4 rounded-2xl shadow-sm flex flex-col items-center justify-center transition-transform hover:scale-105`}>

                  <span className="text-2xl font-bold">{stats[key]}</span>

                  <span className="text-xs uppercase tracking-wider font-semibold opacity-80">{config.label}</span>

                </div>

            ))}

          </div>



          {/* Add Guest Form */}

          <form onSubmit={addGuest} className="mb-8 flex gap-2">

            <input

                type="text"

                value={newName}

                onChange={(e) => setNewName(e.target.value)}

                placeholder="Vendég neve..."

                className="flex-1 px-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all bg-white shadow-sm"

            />

            <button

                type="submit"

                className="bg-indigo-600 text-white px-6 py-3 rounded-xl hover:bg-indigo-700 transition-colors flex items-center gap-2 shadow-lg shadow-indigo-200 active:scale-95"

            >

              <UserPlus size={20} />

              <span className="hidden sm:inline">Hozzáadás</span>

            </button>

          </form>



          {/* Guest List */}

          <div className="bg-white rounded-2xl shadow-md border border-slate-100 overflow-hidden">

            {loading ? (

                <div className="p-12 text-center text-slate-400">Töltés...</div>

            ) : guests.length === 0 ? (

                <div className="p-12 text-center text-slate-400">Még nincs senki a listán. Adj hozzá valakit!</div>

            ) : (

                <ul className="divide-y divide-slate-50">

                  {guests.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0)).map((guest) => {

                    console.log(guest)

                    const StatusIcon = STATUS_CONFIG[guest.status].icon;

                    return (

                        <li key={guest.id} className="p-4 hover:bg-slate-50 transition-colors">

                          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">

                            {/* Name & Status Section */}

                            <div className="flex items-center gap-3 flex-1">

                              <div className={`p-2 rounded-lg ${STATUS_CONFIG[guest.status].color}`}>

                                <StatusIcon size={20} />

                              </div>



                              {editingId === guest.id ? (

                                  <div className="flex items-center gap-2 flex-1">

                                    <input

                                        type="text"

                                        value={editingName}

                                        onChange={(e) => setEditingName(e.target.value)}

                                        className="w-full px-2 py-1 border-b-2 border-indigo-500 focus:outline-none bg-transparent font-medium"

                                        autoFocus

                                    />

                                    <button onClick={() => saveEdit(guest.id)} className="text-green-600 p-1"><Check size={20} /></button>

                                    <button onClick={() => setEditingId(null)} className="text-slate-400 p-1"><X size={20} /></button>

                                  </div>

                              ) : (

                                  <div className="flex-1">

                                    <h3 className="font-semibold text-lg">{guest.name}</h3>

                                    <p className="text-xs text-slate-400 italic">{STATUS_CONFIG[guest.status].label}</p>

                                  </div>

                              )}

                            </div>



                            {/* Actions Section */}

                            <div className="flex items-center gap-2">

                              {/* Status Toggles */}

                              <div className="flex bg-slate-100 p-1 rounded-lg mr-2">

                                {Object.entries(STATUS_CONFIG).map(([key, config]) => (

                                    <button

                                        key={key}

                                        onClick={() => updateStatus(guest.id, key)}

                                        className={`p-1.5 rounded-md transition-all ${

                                            guest.status === key

                                                ? 'bg-white shadow-sm text-indigo-600 scale-110'

                                                : 'text-slate-400 hover:text-slate-600'

                                        }`}

                                        title={config.label}

                                    >

                                      <config.icon size={18} />

                                    </button>

                                ))}

                              </div>



                              {/* Edit/Delete */}

                              <button

                                  onClick={() => startEdit(guest)}

                                  className="p-2 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-all"

                                  title="Szerkesztés"

                              >

                                <Edit2 size={18} />

                              </button>

                              <button

                                  onClick={() => deleteGuest(guest.id)}

                                  className="p-2 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all"

                                  title="Törlés"

                              >

                                <Trash2 size={18} />

                              </button>

                            </div>

                          </div>

                        </li>

                    );

                  })}

                </ul>

            )}

          </div>



          <div className="mt-6 text-center text-slate-400 text-sm">

            Az adatok automatikusan mentésre kerülnek.

          </div>

        </div>

      </div>
      :
          <div>
            <button onClick={loginGoogle}>Google Belépés</button>
          </div>
  );

}
